export const extractErrorMessage = (response) => {
  console.log(response.body); // eslint-disable-line
  return response.body &&
        (typeof response.body === 'object'
          ? response.body.error
          : JSON.parse(response.body).error) || response.statusText || 'Undefined Error';
};



// WEBPACK FOOTER //
// ./src/utils/error.js